import React from "react";
import { FormControl, FormControlLabel, RadioGroup, Radio, Typography } from "@material-ui/core";
import HorizontalPanel from "../../../components/HorizontalPanel";
import { Toolbar } from "../../../app/components";
import { CheckPermission } from "../../../requests/CheckPermission";
import { PERMISSIONS } from "../../../store/userStore/permissions.enum";
import { BulkOperationTypeEnum } from "../BulkOperationType.enum";
import { BulkOperationSubTypeEnum } from "../BulkOperationSubType.enum";

import classes from './index.module.scss';

const BulkOperations = ({
  selectedSubOperation,
  onSubOperationSet,
  selectedOperation,
  onOperationSet,
}: { selectedSubOperation: string, onSubOperationSet: (event) => void, selectedOperation: string, onOperationSet: (event) => void }) => {
  return (
    <HorizontalPanel size={HorizontalPanel.SIZES.WHOLE_SPACE}>
      <HorizontalPanel size={HorizontalPanel.SIZES.SMALL}>
        <Toolbar title="Select operation" />
      </HorizontalPanel>
      <HorizontalPanel size={HorizontalPanel.SIZES.SMALL}>
        <FormControl component="fieldset" className={classes.container}>
          <RadioGroup
            aria-label="sub-operation"
            name="subOperation"
            value={selectedSubOperation}
            onChange={onSubOperationSet}
          >
            <FormControlLabel
              value={BulkOperationTypeEnum.BULK_DEVICE_WORKFLOW}
              control={<Radio />}
              label="Workflow operations"
            />
            <FormControlLabel
              value={BulkOperationTypeEnum.BULK_DEVICE_OWNERSHIP}
              control={<Radio />}
              label="Ownership management"
            />
          </RadioGroup>
        </FormControl>
      </HorizontalPanel>
      <HorizontalPanel size={HorizontalPanel.SIZES.SMALL}>
        <Toolbar title="Select operation type" />
      </HorizontalPanel>
      <HorizontalPanel size={HorizontalPanel.SIZES.REST_SPACE}>
        {
          selectedSubOperation === BulkOperationTypeEnum.BULK_DEVICE_WORKFLOW ? (
            <FormControl component="fieldset" className={classes.container}>
              <RadioGroup aria-label="operation" name="operation" value={selectedOperation} onChange={onOperationSet}>
                <FormControlLabel value={BulkOperationSubTypeEnum.SUBMIT} control={<Radio />} label="Submit" />
                <CheckPermission
                  permissionName={PERMISSIONS.DEVICE_WORKFLOW_UPDATE}
                  noPermissionComponent={(
                    <>
                      <FormControlLabel value={BulkOperationSubTypeEnum.APPROVE} disabled control={<Radio />}
                                        label="Approve" />
                      <FormControlLabel value={BulkOperationSubTypeEnum.REJECT} disabled control={<Radio />}
                                        label="Reject" />
                    </>
                  )}
                >
                  <FormControlLabel value={BulkOperationSubTypeEnum.APPROVE} control={<Radio />} label="Approve" />
                  <FormControlLabel value={BulkOperationSubTypeEnum.REJECT} control={<Radio />} label="Reject" />
                </CheckPermission>
              </RadioGroup>
            </FormControl>
          ) : null
        }
        {
          selectedSubOperation === BulkOperationTypeEnum.BULK_DEVICE_OWNERSHIP ? (
            <FormControl component="fieldset" className={classes.container}>
              <RadioGroup aria-label="operation" name="operation" value={selectedOperation} onChange={onOperationSet}>
                <FormControlLabel value={BulkOperationSubTypeEnum.OWNERS} control={<Radio />} label="Owners list update" />
                <FormControlLabel value={BulkOperationSubTypeEnum.OPERATORS} control={<Radio />} label="Operators List update" />
                <Typography variant="subtitle1">All existing Device Owners, Operators and Frequency Managers list for
                  the selected devices will be replaced with the new list. Be careful, and update only if you are
                  completely sure that new values are actual for every device in the list</Typography>
              </RadioGroup>
            </FormControl>
          ) : null
        }
      </HorizontalPanel>
    </HorizontalPanel>
  )
}

export default BulkOperations;